module.exports = __webpack_public_path__ + "static/media/cert_81.13a1e772.jpg";